import BaseService from "./geral/BaseService";

const base = "SolicitacaoCargaPatio";

export default class CargaPatioDTCService extends BaseService {
    constructor() {
        super(base);
    }

    obterOperacoes(){
        return super.httpGet(`/${base}/operacoes`);
    }

    obterDespachantes(){
        return super.httpGet(`/${base}/despachantes`);
    }

    salvarSolicitacao(solicitacao){
        return super.httpPost(`/${base}/salvar`, solicitacao);
    }

    alterarSolicitacao(solicitacao){
        return super.httpPost(`/${base}/alterar`, solicitacao);
    }

    obterSolicitacao(id){
        return super.httpGet(`/${base}/obter/${id}`);
    }

    filtrarSolicitacoes(operacao = "", container = "", tipoPedido = "T"){
        return super.httpGet(`/${base}/filtrar?operacao=${operacao}&container=${container}&tipoPedido=${tipoPedido}`);
    }

    invalidarSolicitacao(id){
        return super.httpDelete(`/${base}/invalidar/${id}`);
    }
}


// WEBPACK FOOTER //
// ./src/services/CargaPatioDTCService.js